import React from 'react';
import { useLocation } from 'react-router-dom';
import BackendLayout from './backend-layout';
import AuthLayout from './auth-layout';

export default function Layout() {
  const location = useLocation();
  const isAuthLayout = location.pathname.startsWith('/auth');
  if (isAuthLayout) {
    return <AuthLayout />;
  }

  return <BackendLayout />;
}
